import { v4 as uuidv4 } from 'uuid';

function generateNumberFromUuid() {
    // Generate a UUID v4
    const uuidValue = uuidv4();

    // Remove dashes and convert the UUID to a hexadecimal string
    const hexString = uuidValue.replace(/-/g, '');

    // Convert the hexadecimal string to a BigInt integer
    return BigInt('0x' + hexString);
}

export default generateNumberFromUuid;
